module.exports = __webpack_public_path__ + "static/media/solo44.58bad3b3.JPG";